import React, { useContext, useEffect, useState } from "react"
import { red, green } from "@material-ui/core/colors"
import { makeStyles } from "@material-ui/core/styles"
import { CircularProgress } from "@material-ui/core"
import NewReleasesIcon from "@material-ui/icons/NewReleases"
import SaveIcon from "@material-ui/icons/Save"
import StandardsTable from "../components/StandardsTable"
import { SchemaContext } from "../contexts/SchemaContext"
import { MessagingContext } from "../contexts/MessagingContext"
import { UserContext } from "../contexts/UserContext"
import { patchTable, exportTable } from "../api/apiCalls"

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  button: {
    marginBottom: "20px",
  },
  error: {
    color: red[500],
  },
  buttonProgress: {
    color: green[500],
    marginLeft: "10px",
  },
}))

const SchemaPage = () => {
  const [recentlyExported, setRecentlyExported] = useState([])
  const [activated, setActivated] = useState("")
  const classes = useStyles()
  const {
    fetchSchema,
    fetchSchemaTable,
    schemaTable,
    schemaTableDirty,
    schemaTableLoading,
    schemaTableError,
    setSchemaTableDirty,
    setSchemaTableData,
  } = useContext(SchemaContext)
  const { user } = useContext(UserContext)
  const { addErrorMessage, addSuccessMessage } = useContext(MessagingContext)
  const saveableTables = [
    "conversionfactors",
    "megafilemarkets",
    "readersforcopy",
    "product",
    "channelsubchannel",
    "demo",
  ]

  useEffect(() => {
    if (schemaTableDirty) {
      fetchSchemaTable(user)
    }
  }, [user, fetchSchemaTable, schemaTableDirty])

  const reloadSchema = () => {
    fetchSchema(user)
    setSchemaTableDirty()
  }

  const invalidateSchema = (buttonID, folder_name) => {
    setActivated(folder_name)
    patchTable(user, "schema", {
      id: buttonID,
      schema_valid: false,
      folder_name,
    }).then(() => {
      setActivated("")
      const { data } = schemaTable
      const elementPos = data
        .map(function (x) {
          return x.id
        })
        .indexOf(buttonID)
      const objectFound = data[elementPos]
      data[elementPos] = { ...objectFound, schema_valid: false }
      setSchemaTableData(data)
    })
  }

  const exportToS3 = (tablename) => {
    setActivated(tablename)
    exportTable(user, tablename)
      .then((data) => {
        setActivated("")
        if (data.statusCode === 200) {
          addSuccessMessage(tablename, `loaded as ${data.newFile}`)
          setRecentlyExported([
            ...recentlyExported,
            { tablename, path: data.newFile },
          ])
        } else {
          addErrorMessage(tablename, "cannot be loaded to s3.")
        }
      })
      .catch((err) => console.log(err))
  }

  return (
    <div>
      {schemaTableLoading && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
      {schemaTableError && <p className={classes.error}>{schemaTableError}</p>}
      {schemaTable && !schemaTableLoading && !schemaTableError && (
        <StandardsTable
          title="Schema"
          value="schema"
          editable={[]}
          data={schemaTable.data}
          columns={schemaTable.columns}
          loading={schemaTableLoading}
          error={schemaTableError}
          callback={reloadSchema}
          actions={[
            (rowData) => ({
              icon: NewReleasesIcon,
              tooltip: `Invaildate ${rowData.label} Schema`,
              onClick: (event, rowData) => {
                invalidateSchema(rowData.id, rowData.folder_name)
                rowData.schema_valid = false
              },
              hidden: !rowData.upload,
              disabled: !rowData.schema_valid,
              activated: activated === rowData.folder_name,
            }),
            (rowData) => ({
              icon: SaveIcon,
              tooltip: `Save ${rowData.label} csv to s3 - query/${rowData.folder_name}`,
              onClick: () => {
                exportToS3(rowData.folder_name)
              },
              hidden: !saveableTables.includes(rowData.folder_name),
              disabled: recentlyExported
                .map((recentExport) => recentExport.tablename)
                .includes(rowData.folder_name),
              activated: activated === rowData.folder_name,
            }),
          ]}
          actionsColumnIndex={3}
        />
      )}
    </div>
  )
}

export default SchemaPage
